import {useState, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {userProfileBiz} from '../biz/userProfileBiz'

export default function UserProfileMenu() {
  const agentSlice = useSelector((state) => state.agent)
  const [userProfile, setUserProfile] = useState({})

  useEffect(() => {
    getUserProfile()
    // console.log(userProfile)
  }, [])

  const getUserProfile = async () => {
    const result = await userProfileBiz.search(agentSlice._id)
    setUserProfile(result)
  }

  return (
    <>
    <div className='detail'>
      <div className='name'>
      {userProfile.UserName}
        <div className='role'>{userProfile.UserAgentNo ? `${userProfile.UserAgentCode} ${userProfile.UserAgentNo}` : 'Admin'}</div>
      </div>
      <div className='branch'>
        Branch: {userProfile.UserGroupName}
      </div>
      <div className='email'>
        {userProfile.UserEmail}
      </div>
    </div>
    </>
  )
}
